import React from "react";

export default function SelectBusiness({ listings = [], userName, onSelect, loading = false }) {
    return (
        <div className="select-biz-wrap">
            <div className="select-biz-card">
                <div className="text-center mb-4">
                    <img src="/logo.png" alt="DialNepal" style={{ height: 46 }} />
                    <h4 className="fw-bold mt-3 mb-1">Welcome{userName ? `, ${userName}` : ""} 👋</h4>
                    <p className="text-muted mb-0">
                        {loading ? "Loading your businesses…" : "Select a business to manage"}
                    </p>
                </div>

                {loading ? (
                    <div className="biz-loader">
                        <div className="biz-spinner" role="status" aria-label="Loading"></div>
                        <p className="text-muted mt-3 mb-4">Fetching your businesses, please wait…</p>
                        <div className="row g-3 w-100">
                            {[0, 1, 2, 3].map((i) => (
                                <div className="col-md-6" key={i}>
                                    <div className="biz-skeleton">
                                        <div className="sk-icon shimmer"></div>
                                        <div className="sk-lines">
                                            <div className="sk-line shimmer" style={{ width: "70%" }}></div>
                                            <div className="sk-line shimmer" style={{ width: "45%" }}></div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="row g-3">
                            {listings.map((l) => (
                                <div className="col-md-6" key={l.listinguid}>
                                    <button className="biz-pick w-100 text-start" onClick={() => onSelect(l.listinguid)}>
                                        <div className="d-flex align-items-center gap-3">
                                            <div className="biz-icon"><i className="bi bi-shop"></i></div>
                                            <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                                <div className="fw-semibold text-dark text-truncate">{l.title}</div>
                                                <small className="text-muted d-block text-truncate">
                                                    {l.province}{l.district ? `, ${l.district}` : ""}
                                                </small>
                                                <span className={`badge mt-1 ${l.states == 1 ? "bg-success" : "bg-warning text-dark"}`}>
                                                    {l.states == 1 ? "Approved" : "Pending"}
                                                </span>
                                            </div>
                                            <i className="bi bi-chevron-right text-muted"></i>
                                        </div>
                                    </button>
                                </div>
                            ))}
                        </div>

                        <div className="text-center mt-4">
                            <a href="/add-listing" className="btn btn-outline-primary">
                                <i className="bi bi-plus-circle me-1"></i> Add a new business
                            </a>
                        </div>
                    </>
                )}
            </div>

            <style>{`
                .select-biz-wrap {
                    min-height: 100vh;
                    background: linear-gradient(135deg, #eef3ff, #f7f9fc);
                    display: flex; align-items: center; justify-content: center; padding: 24px;
                }
                .select-biz-card {
                    background: #fff; border-radius: 18px;
                    box-shadow: 0 12px 40px rgba(0,0,0,0.10);
                    padding: 32px; width: 100%; max-width: 760px;
                }
                .biz-pick { border: 1px solid #e5e7eb; background: #fff; border-radius: 12px; padding: 14px 16px; transition: 0.2s; }
                .biz-pick:hover { border-color: #2563eb; box-shadow: 0 6px 18px rgba(37,99,235,0.12); transform: translateY(-2px); }
                .biz-icon { width: 46px; height: 46px; border-radius: 10px; background: #eef3ff; color: #2563eb; display: flex; align-items: center; justify-content: center; font-size: 1.3rem; flex: 0 0 46px; }

                /* ---- Loader ---- */
                .biz-loader { display: flex; flex-direction: column; align-items: center; text-align: center; }
                .biz-spinner {
                    width: 54px; height: 54px; border-radius: 50%;
                    border: 5px solid #e3eaff; border-top-color: #2563eb;
                    animation: biz-spin 0.9s linear infinite;
                }
                @keyframes biz-spin { to { transform: rotate(360deg); } }

                .biz-skeleton { display: flex; align-items: center; gap: 12px; border: 1px solid #eef0f3; border-radius: 12px; padding: 14px 16px; background: #fff; }
                .sk-icon { width: 46px; height: 46px; border-radius: 10px; flex: 0 0 46px; }
                .sk-lines { flex: 1; display: flex; flex-direction: column; gap: 8px; }
                .sk-line { height: 12px; border-radius: 6px; }

                .shimmer {
                    background: linear-gradient(90deg, #eef1f6 25%, #e2e7ef 37%, #eef1f6 63%);
                    background-size: 400% 100%;
                    animation: shimmer 1.3s ease-in-out infinite;
                }
                @keyframes shimmer { 0% { background-position: 100% 0; } 100% { background-position: -100% 0; } }
            `}</style>
        </div>
    );
}
